module.exports = __webpack_public_path__ + "static/media/SignIn.8ff7d4d7.svg";